import { render, staticRenderFns } from "./ProcForm.vue?vue&type=template&id=2c765874&"
import script from "./ProcForm.vue?vue&type=script&lang=js&"
export * from "./ProcForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports